import FullSupplyCostReceiptAmounts from './full-supply-cost-receipt-amounts'

const ComparisonReceiptValue = ({
  alignment,
  comparison,
  currencyCode = 'USD',
  emphasis,
}: FullSupplyCostReceiptAmountsProps) => (
  <FullSupplyCostReceiptAmounts
    alignment={alignment}
    comparison={comparison}
    currencyCode={currencyCode}
    emphasis={emphasis}
  />
)

export default ComparisonReceiptValue
